import { Outlet, useNavigate, useSearchParams, useLocation } from 'react-router-dom'
import { RoutePath } from '@/routes'
import React, { useEffect, useState } from 'react'
import { Toaster } from 'react-hot-toast'
import { useScroll } from '@/components/layouts/ScrollContext'
import { apiInstance } from '@/apiInstance'
import { AxiosError } from 'axios'
import './Layout.css'

export default function Layout() {
  const navigate = useNavigate()
  const location = useLocation()
  let [searchParams] = useSearchParams()
  const [isLoading, setIsLoading] = useState(true)

  const { layoutContentRef } = useScroll()

  useEffect(() => {
    const checkAuth = async () => {
      try {
        if (location.pathname.startsWith('/login')) {
          setIsLoading(false)
          // no need to redirect on login page
          return
        }
        // First check if we have a token
        if (!apiInstance.authToken) {
          // Only set redirectTo if not already set and not on login page
          const currentRedirectTo = localStorage.getItem('redirectTo')
          if (!currentRedirectTo && location.pathname !== RoutePath.LOGIN) {
            const queryString = searchParams.toString()
            const fullPath = location.pathname + (queryString ? `?${queryString}` : '')
            localStorage.setItem('redirectTo', fullPath)
          }
          navigate(RoutePath.LOGIN + (searchParams.toString() ? `?${searchParams.toString()}` : ''))
          return
        }

        // Try to get games to verify authentication
        await apiInstance.getGames()
        setIsLoading(false)
      } catch (error) {
        if (error instanceof AxiosError && error.response?.status === 401) {
          // Clear any invalid tokens
          apiInstance.authToken = undefined
          // Only set redirectTo if not already set and not on login page
          const currentRedirectTo = localStorage.getItem('redirectTo')
          if (!currentRedirectTo && location.pathname !== RoutePath.LOGIN) {
            const queryString = searchParams.toString()
            const fullPath = location.pathname + (queryString ? `?${queryString}` : '')
            localStorage.setItem('redirectTo', fullPath)
          }
          navigate(RoutePath.LOGIN + (searchParams.toString() ? `?${searchParams.toString()}` : ''))
        } else {
          setIsLoading(false)
        }
      }
    }

    checkAuth()
  }, [navigate, location.pathname, searchParams])

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-[#FEF9EC] to-white p-8 flex items-center justify-center">
        <div className="text-center">
          <p className="text-lg">Loading...</p>
        </div>
      </div>
    )
  }

  return (
    <main className="layout">
      <div className="layout-content" ref={layoutContentRef}>
        <Outlet />
      </div>
      <Toaster />
    </main>
  )
}
